import homeView from './index'
import searchView from './search'
import bookView from './book'

import model from './services/model'

const hotelDC = 3

const hotelViews = {
  path: 'hotel',
  component: homeView,
  name: 'Private/Hotel',
  redirect: { name: 'Private/Hotel/Search' },
  children: [
    {
      path: 'search',
      component: searchView,
      name: 'Private/Hotel/Search'
    },
    {
      path: 'book/:Result/:Category/:Meal/:Distribution',
      component: bookView,
      name: 'Private/Hotel/Book'
    }
  ],
  async beforeEnter (to, from, next) {
    if (!model.initDataLoaded || model.params.distribution !== hotelDC) {
      await model.init({ dc: hotelDC })
      next()
    } else {
      next()
    }
  }
}

const villasDC = 4

const villasViews = {
  path: 'villas',
  component: homeView,
  name: 'Private/Villas',
  redirect: { name: 'Private/Villas/Search' },
  children: [
    {
      path: 'search',
      component: searchView,
      name: 'Private/Villas/Search'
    },
    {
      path: 'book/:Result/:Category/:Meal/:Distribution',
      component: bookView,
      name: 'Private/Villas/Book'
    }
  ],
  async beforeEnter (to, from, next) {
    if (!model.initDataLoaded || model.params.distribution !== villasDC) {
      await model.init({ dc: villasDC })
      next()
    } else {
      next()
    }
  }
}

export { hotelViews, villasViews }
